import axios from 'axios';

export const publicAdapter = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
});
